import jQuery from 'jquery'; // Required for Slick import.
import '@accessible360/accessible-slick';

(($) => {
  $(() => {
    const $popularCollections = $('.section--popular-collections .popular-collections');

    if ($popularCollections.length) {
      const slickSettings = {
        autoplay: false,
        arrows: true,
        appendArrows: $popularCollections,
        dots: false,
        infinite: true,
        rows: 0,
        slidesToShow: 5,
        slidesToScroll: 5,
        responsive: [
          {
            breakpoint: 1400,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 1,
            }
          },
        ]
      };

      $popularCollections.find('.popular-collections__slider').slick(slickSettings);
    }
  });
})(jQuery);
